export default function reportError(error) {
  console.warn('Error occured on gatsby CMS', error)
}



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/services/errorReporting.js